import { cn } from '@/utils/styles';
import { AlertCircle, AlertTriangle, CircleCheck, Info } from 'lucide-react';

import React from 'react';

interface InfoBannerProps {
	message: string;
	variant?: 'info' | 'success' | 'warning' | 'error';
	className?: string;
}

const variantConfig = {
	info: {
		icon: Info,
		className: 'bg-blue-50 text-blue-800 border-blue-200',
	},
	success: {
		icon: CircleCheck,
		className: 'bg-amber-700 text-primary-foreground',
	},
	warning: {
		icon: AlertTriangle,
		className: 'bg-yellow-50 text-yellow-800 border-yellow-200',
	},
	error: {
		icon: AlertCircle,
		className: 'bg-red-50 text-red-800 border-red-200',
	},
};

function InfoBanner({ message, variant = 'info', className }: InfoBannerProps) {
	const config = variantConfig[variant];

	return (
		<div
			className={cn(
				'px-4 py-3 text-center text-sm font-medium shadow-sm',
				config.className,
				className
			)}
		>
			<div className="flex items-center justify-center gap-2">
				<span>{message}</span>
			</div>
		</div>
	);
}

export default InfoBanner;
